import { CardMedia, Skeleton } from "@mui/material";
import { useAtomValue } from "jotai";
import { loadable } from "jotai/utils";
import type { FC } from "react";
import type { BrandInfoSelected } from "../../brand-kit/types";
import type { LibraryTemplate } from "../library/types";
import { discoverTemplateImageFamily } from "../store";

export const MomentImage: FC<{
  template: LibraryTemplate;
  brandKitSelections: BrandInfoSelected | undefined;
}> = ({ template, brandKitSelections }) => {
  const imageLoader = useAtomValue(
    loadable(
      discoverTemplateImageFamily({
        slug: template.slug,
        img: template.img,
        style: brandKitSelections?.branding_type || { type: "standard", value: "bold" },
      }),
    ),
  );

  const url =
    imageLoader?.state === "hasData" && imageLoader.data ? imageLoader.data.url : undefined;

  return (
    <>
      {url?.state === "hasData" && url.data ? (
        <CardMedia
          component="img"
          image={url.data}
          sx={{ position: "absolute", width: "100%", height: "100%" }}
          draggable={false}
        />
      ) : (
        <Skeleton
          variant="rectangular"
          sx={{ position: "absolute", width: "100%", height: "100%" }}
        />
      )}
    </>
  );
};
